<template>
	<div
		class="booking-card"
		role="button"
		tabindex="0"
		@click="onClick"
		@keyup.enter="onClick">
		<BCard>
			<div class="d-flex justify-content-between align-items-center">
				<div>
					{{ booking.frequency }} {{ booking.service }} <span class="text-muted">clean</span>
				</div>
				<BBadge :variant="booking.status === 'Accepted' || booking.status === 'Confirmed' ? 'primary' : 'light'" size="sm">
					{{ booking.status }}
				</BBadge>
			</div>
			<BRow>
				<BCol>
					{{ booking.address }}, {{ booking.suburb.name }}
					<div class="text-muted">
						{{ booking.days }} {{ pluralize('day', booking.days) }}
						{{ booking.hours }} {{ pluralize('hour', booking.hours) }}
					</div>
				</BCol>
			</BRow>
			<div class="my-2 mt-2"></div>
			<div>
				<h5 class="font-weight-bold mb-0">
					Your Cleaner
				</h5>
				<template v-if="!booking.cleaner">
					We're looking for a cleaner...
				</template>
				<template v-else>
					{{ booking.cleaner.first_name }} {{ booking.cleaner.last_name }}
					<a :href="`tel:${booking.cleaner.phone}`" class="text-blue"
						@click.stop>
						{{ booking.cleaner.phone }}
					</a>
				</template>
			</div>
		</BCard>
	</div>
</template>

<script>
	import { pluralize } from '@js/utilities/index.js';

	export default {
		props: {
			booking: {
				type: Object,
				required: true
			}
		},
		methods: {
			pluralize,
			onClick() {
				this.$router.push({ path: `/bookings/${this.booking.unique_id}` })
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../../../sass/_variables';

  .booking-card .card {
	  transition: all 150ms ease-out;
  }

  .booking-card {
	  cursor: pointer;

	  &:hover .card,
	  &:focus .card {
		  border: 1px solid $orange;
		  background: rgba($orange, 0.025);
		  color: $orange;
	  }
  }
</style>
